import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import INDIA_TOPOJSON from "../../india.json";
import { axInst } from "../../Components/Login/Service";

// API call function
const fetchStateWiseData = async (body) => {
  try {
    const res = await axInst.post(
      "complaints/workshop_wise_open_complaint",
      body
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

const IndiaMap = () => {
  const [hoverInfo, setHoverInfo] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  // Get filter data from Redux store
  const { data, submitted } = useSelector((state) => state.filtersComplaint);

  // Fetch API data
  const { data: stateWiseData } = useQuery({
    queryKey: ["state", submitted],
    queryFn: () => fetchStateWiseData(data),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  return (
    <div className="p-2">
      <h2 className="text-base font-semibold text-[#474747]">
        Workshop Wise Complaints
      </h2>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <ComposableMap
          projection="geoMercator"
          projectionConfig={{ center: [80, 22], scale: 900 }}
          width={700}
          height={600}
          style={{ width: "100%", height: "100%" }}
        >
          <Geographies geography={INDIA_TOPOJSON}>
            {({ geographies }) =>
              geographies.map((geo) => {
                const stateName = geo.properties.st_nm;
                const hasWorkshops = stateWiseData?.[stateName];

                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    onMouseEnter={(event) => {
                      const { clientX, clientY } = event;
                      setHoverInfo({
                        state: stateName,
                        workshops: hasWorkshops ? hasWorkshops.length : 0,
                        x: clientX,
                        y: clientY,
                      });
                    }}
                    onMouseMove={(event) => {
                      const { clientX, clientY } = event;
                      setHoverInfo((prev) => ({
                        ...prev,
                        x: clientX,
                        y: clientY,
                      }));
                    }}
                    onMouseLeave={() => setHoverInfo(null)}
                    onClick={() => {
                      if (hasWorkshops) {
                        setSelectedState({
                          state: stateName,
                          workshops: hasWorkshops,
                        });
                      }
                    }}
                    style={{
                      default: {
                        fill: hasWorkshops ? "#A0D2EB" : "#E0E0E0",
                        stroke: "#000",
                        strokeWidth: 0.5,
                      },
                      hover: { fill: "#FFCC00" },
                    }}
                  />
                );
              })
            }
          </Geographies>
        </ComposableMap>

        {hoverInfo && (
          <div
            style={{
              position: "fixed",
              top: hoverInfo.y + 10,
              left: hoverInfo.x + 10,
              backgroundColor: "white",
              padding: "8px",
              borderRadius: "5px",
              boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.3)",
              pointerEvents: "none",
              zIndex: 1000,
            }}
          >
            <p>No. of Workshops: {hoverInfo.workshops}</p>
          </div>
        )}

        {selectedState && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              borderRadius: "8px",
              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.3)",
              zIndex: 2000,
              minWidth: "260px",
              textAlign: "center",
            }}
          >
            <h3 className="font-bold text-white text-lg p-2 rounded-t-lg bg-gradient-to-r from-[#2670DF] to-[#677eca] z-80">
              {selectedState.state}
            </h3>

            <table className="block min-w-full table-auto bg-white rounded-lg  border-gray-800 p-2">
              <thead>
                <tr className="text-black  p-3 rounded-lg text-sm opacity-80">
                  <th className="border border-gray-400 pl-3 bg-slate-300 pr-3 whitespace-nowrap">
                    Workshop Name
                  </th>
                  <th className="border border-gray-400 bg-slate-300 pl-6 pr-8">
                    Complaints
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* Loop through each workshop */}
                {selectedState.workshops.map((workshop, index) => (
                  <tr
                    key={index}
                    className={`hover:bg-gray-100 ${
                      index % 2 !== 0
                        ? "bg-gradient-to-l from-slate-300 to-blue-300"
                        : "bg-[#FFFFFF]"
                    }`}
                  >
                    <td className="border border-b border-gray-400 text-xs opacity-70">
                      {workshop.workshopName}
                    </td>
                    <td className="border border-b border-gray-400 text-xs  opacity-70">
                      {workshop.complaints}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <button
              className=" text-[#7A9ED6] px-3 rounded underline "
              onClick={() => setSelectedState(null)}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default IndiaMap;
